import './SubscriptionPage.css';
import { useState, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from "react-oidc-context";
import { createSubscriptionLink, getSubscriptionInfo } from 'api';
import { useExtendedMutation } from 'mutations';
import { GridRowInnerBox, ScrollablePageWrapper } from 'components';

const SubscriptionPage = () => {
    const [authenticated, setAuthenticated] = useState(false)
    const [subscriptionInfo, setSubscriptionInfo] = useState([]);
    const auth = useAuth();
    const token = auth.user?.access_token;

    const subscriptionLinkSuccessCallback = (data) => {
        window.location.href = data.url;
    }

    const errorCallback = (error) => {
        console.error('Error getting data:', error);
    }

    const getSubscriptionInfoSuccessCallback = (data) => {
        setSubscriptionInfo(data);
    }

    const createSubscriptionLinkMutation = useExtendedMutation(
        createSubscriptionLink,
        subscriptionLinkSuccessCallback,
        errorCallback);
    const getSubscriptionInfoMutation = useExtendedMutation(
        getSubscriptionInfo,
        getSubscriptionInfoSuccessCallback,
        errorCallback);
    
    const onClick = (subscriptionType) => {
        createSubscriptionLinkMutation.mutateOnVirtualThread({ subscriptionType, token });
    };

    useEffect(() => {
        if (auth.isAuthenticated && auth.user) {
            setAuthenticated(true);
        }
    }, [auth.isAuthenticated, auth.user]);

    useEffect(() => {
        getSubscriptionInfoMutation.mutateOnVirtualThread({token});
        const interval = setInterval(() => {
            getSubscriptionInfoMutation.mutateOnVirtualThread({token});
        }, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    const stripeTooltip = "Hey there!\n\nFunctionality still in progress.\n\nWe are not fully integrated with Stripe yet! If you click further you will be led to a Stripe test page which will not let you pay.";

    if (authenticated) {
        return(
            <ScrollablePageWrapper mobileOnly>
            <div className ="container py-5 subscription-container">
                <div className ="row justify-content-center">
                    <GridRowInnerBox
                        listItems =
                        {
                            [
                                'Access to beta library titles',
                                'Limit of 25 chapter cards',
                                'Limit of 50 private cards',
                                'Free access'
                            ]
                        }
                        title = {'Basic'}
                    />
                    <GridRowInnerBox
                        listItems =
                        {
                            [
                                'Full access to the complete library collection',
                                'Limit of 200 chapter cards',
                                'Limit of 2,000 private cards',
                                'Ability to share and exchange word lists with friends',
                                'Monthly subscription fee'
                            ]
                        }
                        title = {'Plus'}
                        buttonText = {'Get Plus'}
                        onButtonClick = {() => onClick('plus')}
                        buttonTooltip = {stripeTooltip}
                    />
                    <GridRowInnerBox
                        listItems =
                        {
                            [
                                'Full access to the complete library collection', 
                                'Limit of 200 chapter cards', 
                                'Limit of 2,000 private cards',
                                'Ability to share and exchange word lists with friends',
                                'Annual subscription fee'
                            ]
                        }
                        title = {'Amethyst Society'}
                        buttonText = {'Join Amethyst'}
                        onButtonClick = {() => onClick('amethyst')}
                        buttonTooltip = {stripeTooltip}
                    />
                </div>
            </div>
            </ScrollablePageWrapper>
        )
    } else {
        return(<div></div>)
    }
}

export { SubscriptionPage }